import { memoizedGet } from './object.esm.js';
import { themeFontIndexToFontSize, resolveSize, getStepSize } from './size-utils.esm.js';

function sizeSynchronize (size, theme) {
  var stepIconSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var stepSpinnerSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  return {
    fontSize: themeFontIndexToFontSize(theme, resolveSize(size, memoizedGet(theme, 'sizes.font'))),
    spinnerSize: getStepSize(size, stepSpinnerSize),
    iconSize: getStepSize(size, stepIconSize)
  };
}

export default sizeSynchronize;
//# sourceMappingURL=size-synchronize.esm.js.map
